import  gql  from 'graphql-tag'

export const officeReports = gql`query Office($id: ID!, $reportStartDate: Date, $reportEndDate: Date){ 
    officeReports: office(id:$id){
        id
        name
        creditanalystSet{
            edges{
                node{
                    user{
                        id
                        name
                        surname
                    }
                    inProcess(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    finished(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    averageTime(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    productionActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    commerceActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                    servicesActivityCount(reportStartDate:$reportStartDate, reportEndDate: $reportEndDate)
                }
            }
        }
    }
}`;
